module.exports = __webpack_public_path__ + "img/photo_2023-05-16 19.14.45.c4c90350.jpeg";